$(document).ready(function () {
console.log('ready')
    $('.slick-carousel').slick({
        rtl: true
    });

})
